/* ============================================================
   FEED PRIORITY (feed-priority.js) — BENTON'S HOME-FEED CONTROLS
   ------------------------------------------------------------
   WEEKLY ROTATION (Benton, 2026-10-12): the site keeps itself in
   motion with zero redeploys. Every Monday the opening lineup
   rotates automatically:
     · the P1 opener advances through P1_ROTATION
     · the Priority-2 head-of-line order rotates by one
   The deeper feed already shuffles on EVERY visit (restq), so no
   two scrolls are ever identical past the opening stretch.

   TO CHANGE WHAT ROTATES: edit P1_ROTATION / P2_HEAD below (tell
   Claude, or edit the Placement column in the Content Registry
   sheet and say "sync"). Pinning one opener (e.g. during a
   single push) = reduce P1_ROTATION to that one id.

   Home-feed cadence (Benton, 2026-09-11):
     P1 video → merch ad → 3 Priority-2 videos → (repeat:
     merch ad → 3 more P2s …) until content runs out.
   ============================================================ */

/* NEW SINGLE — "I Don't Get High Anymore" (Benton, 2026-09-25):
   group-share guitar clip, ingested to the Shopify CDN. Defined
   here (not in feed-items.js) so the generated file stays a
   clean mirror of the Feed Script sheet; this push runs after
   feed-items.js loads and before feed.js reads FEED_ITEMS. */
FEED_ITEMS.push(
  {id: "h12", type: "video", category: "albums", album: "singles",
   hostedSrc: "https://cdn.shopify.com/videos/c/vp/f11fa0c927be4393a1d7851c324b06c2/f11fa0c927be4393a1d7851c324b06c2.HD-720p-4.5Mbps-95579431.mp4",
   hostedSrcHd: "https://cdn.shopify.com/videos/c/vp/f11fa0c927be4393a1d7851c324b06c2/f11fa0c927be4393a1d7851c324b06c2.HD-1080p-7.2Mbps-95579431.mp4",
   orientation: "vertical", duration: 39,
   title: "I Don't Get High Anymore",
   caption: "The new single. Out everywhere now.",
   tags: ["#IDontGetHighAnymore", "#NewMusic"], likes: 2800}
);

/* Weeks since epoch, aligned so the number advances every MONDAY
   (local to each fan's clock — close enough for a vibe rotation).
   ROTATION_PHASE anchors the cycle: launch week (2026-10-12) =
   slot 0, so the new single keeps the opener through this week
   and the rotation begins advancing next Monday. */
const FEED_WEEK = Math.floor((Date.now() / 864e5 + 3) / 7) + 2;

/* P1 OPENERS — Benton's pool, one leads the feed each week.
   Hosted vertical clips only (instant, full-bleed). Order: */
const P1_ROTATION = [
  'h12',  // I Don't Get High Anymore — the new single
  'h11',  // BROWN$DOWN — the viral clip
  'h1',   // Chicano Poetry — The Observatory (live)
  'h8',   // "People get lost, high, or pray" — talk-to-camera
];
const FEED_P1 = [P1_ROTATION[FEED_WEEK % P1_ROTATION.length]];

/* PRIORITY-2 HEAD OF LINE (from Obed's real social traction,
   checked on TikTok + Instagram 2026-09-14) — the order rotates
   weekly so slots 2-5 reshuffle too; everything after them still
   ranks by likes. */
const P2_HEAD = [
  'sh3',    // There's 2 types of Mexicans (Short)
  'a-rc1',  // RODEO CLOWN — Official Video
  'sh7',    // From Brown & Down to Rodeo Clown (Short)
  'sh1',    // The Rodeo Clown — Short
];
const P2_OFF = FEED_WEEK % P2_HEAD.length;
const FEED_P2_FIRST = P2_HEAD.slice(P2_OFF).concat(P2_HEAD.slice(0, P2_OFF))
  // never open slot 2 with the same clip that already led the feed
  .filter(id => id !== FEED_P1[0]);
